module.exports = __webpack_public_path__ + "assets/images/9gd.jpg";